
import React, { Component } from 'react';
import { Modal, Icon, Button, Upload, Divider, Tooltip } from 'antd';
import http from '../../../axios/http';
import Loading from '../../ui/Loading';
import messager from '../../ui/messager';
import '../../../style/common/uploadImage.css';
import server from '../../../axios/server'
import PdfView from '../../ui/PdfView'

class ContractManageFile extends Component {

    state = {
        visible: false,
        loadingVisible: false,
        fileList: [],
        url: '',
        pdfVisible: false,
        pdfData: {},
        view: {},
        isBlock: 'none'
    }

    componentDidMount() {
        this.props.initFile(this.initFile);
        let url = '';
        url = server.httpServerUrl + '/market/contract/upload/pdf'
        this.setState({
            url: url,
        });
        let clientW = document.body.clientWidth
        let clientH = document.body.clientHeight
        this.setState({
            clientW: clientW,
            clientH: clientH
        })
    }


    initFile = (fileData) => {
        if (fileData.pdffileList !== undefined) {
            let fileList = [];
            for (let i = 0; i < fileData.pdffileList.length; i++) {
                fileList.push({
                    uid: fileData.pdffileList[i].id,
                    name: fileData.pdffileList[i].fileName,
                    url: server.httpServerUrl + '/market/contract/download/pdf?url=' + encodeURI(fileData.pdffileList[i].pdfUrl),
                    status: 'done',
                })
            }
            this.setState({
                fileList: fileList
            })
        }
    }
    handleChange = info => {
        let fileList = [...info.fileList];
        // fileList = fileList.slice(-2);
        fileList = fileList.map(file => {
            if (file.response) {
                if (this.props.fileData.pdffileList === undefined) {
                    this.props.fileData.pdffileList = []
                }
                file.url = server.httpServerUrl + '/market/contract/download/pdf?url=' + encodeURI(file.response.data[0].pdfUrl);
                file.uid = file.response.data[0].id;
                file.id = file.response.data[0].id;
                // this.props.fileData.pdffileList.push(file.response.data[0])
            }
            return file;
        });
        this.setState({ fileList });
    };



    remove = (info) => {
        let pdffileList = this.props.fileData.pdffileList;
        for (let i = 0; i < this.props.fileData.pdffileList.length; i++) {
            if (info.uid === this.props.fileData.pdffileList[i].id) {
                pdffileList.splice(i, 1);
            }
        }
        http.post({
            url: '/market/contract/upload/pdf/delete',
            data: { "id": info.uid },
            success: (res) => {
                messager.notify("删除成功！");
                // this.initFile();
            },
            error: (res) => {
            }
        });

    }
    downLoadContract = (type) => {
        this.setState({ loadingVisible: true });
        const { fileData } = this.props;
        let url = '';
        let fileName = ''
        if (type === 'LeaseContract') {
            url = '/market/contract/download/downloadLeaseContract'
            fileName = fileData.clientName + "  商铺租赁合同.docx"
        } else if (type === 'BusiContract') {
            url = '/market/contract/download/downloadBusiContract'
            fileName = fileData.clientName + "  商业管理服务合同.docx"
        }
        http.download({
            url: url,
            data: { "id": fileData.id,type:'docx' },
            fileName: fileName,
            success: (res) => {
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
            }
        });
    }


    previewPdf = (type) => {
        this.setState({ loadingVisible: true })
        const { fileData } = this.props;
        let url = '';
        let fileName = '';
        if (type === 'LeaseContract') {
            url = '/market/contract/download/downloadLeaseContract'
            fileName = fileData.clientName + "  商铺租赁合同.pdf"
        } else if (type === 'BusiContract') {
            url = '/market/contract/download/downloadBusiContract'
            fileName = fileData.clientName + "  商业管理服务合同.pdf"
        }
        this.setState({ isBlock: 'block' })

        this.setState({ pdfVisible: true })
        setTimeout(() => {
            let view = this.refs["pdfView"];
            view.loadFile({
                url: url,
                fileName: fileName,
                data: { "id": fileData.id },
                saveFile: false,
            });
        })
        this.setState({ loadingVisible: false })
    }
    hiddenPdflModal = () => {
        this.setState({
            pdfVisible: false,
            isBlock: 'none'
        })
    }
    render() {
        const { visible, onCancel, fileData } = this.props;
        return (
            <div>
                <Modal
                    width={600}
                    height={900}
                    visible={visible}
                    title="附件"
                    okText="确定"
                    cancelText="取消"
                    maskClosable={false}
                    onCancel={onCancel}
                    onOk={this.save}
                    afterClose={() => {
                        this.setState({ activeKey: 'file' });
                        this.setState({ fileList: [] })
                    }}
                    zIndex="10"
                    footer={[
                        <Button key="cancel" type="default" onClick={onCancel}>关闭</Button>,
                    ]}
                >
                    <Divider orientation="left" style={{ marginTop: 0 }}>合同模板</Divider>
                    <div style={{ width: '100%', overflow: 'hidden' }}>
                        <div className="fileBtn" style={{ color: '#1890ff', cursor: 'pointer', width: '75%', float: "left" }}>
                            商铺租赁合同.docx
                                </div>
                        <div style={{ float: "right" }}>
                            <Tooltip title="预览" onClick={this.previewPdf.bind(this, 'LeaseContract')}>
                                <Icon type="eye" className="table-operate-icon" />
                            </Tooltip>
                            {
                                fileData.status === 'AUDITED' ? <Tooltip title="下载" onClick={this.downLoadContract.bind(this, 'LeaseContract')}>
                                    <Icon type="download" className="table-operate-icon" />
                                </Tooltip> : ''
                            }
                        </div>
                    </div>
                    <div style={{ width: '100%', overflow: 'hidden', marginTop: 10 }}>
                        <div className="fileBtn" style={{ color: '#1890ff', cursor: 'pointer', width: '75%', float: "left" }}>
                            商业管理服务合同.docx
                                </div>
                        <div style={{ float: "right" }}>
                            <Tooltip title="预览" onClick={this.previewPdf.bind(this, 'BusiContract')}>
                                <Icon type="eye" className="table-operate-icon" />
                            </Tooltip>
                            {
                                fileData.status === 'AUDITED' ?
                                    <Tooltip title="下载" onClick={this.downLoadContract.bind(this, 'BusiContract')}>
                                        <Icon type="download" className="table-operate-icon" />
                                    </Tooltip> : ''
                            }
                        </div>
                    </div>
                    <Divider orientation="left" >上传附件</Divider>
                    <Upload
                        action={this.state.url}
                        onChange={this.handleChange}
                        multiple={true}
                        fileList={this.state.fileList}
                        data={{ id: fileData.id }}
                        withCredentials={true}
                        // onDownload={this.downLoad}
                        onRemove={this.remove}
                        accept=".pdf"
                    >
                        <Button>
                            <Icon type="upload" /> 上传附件
                                </Button>
                    </Upload>

                    <Loading
                        visible={this.state.loadingVisible}
                        message="加载中"
                    />
                </Modal>
                {
                    this.state.pdfVisible ?
                        <div style={{ position: 'absolute', top: '50%', left: '50%', zIndex: 11, transform: ' translate(-50%, -50%)' }}>
                            <div style={{ height: this.state.clientH - 200, width: this.state.clientW - 600, background: '#525659' }} >
                                <div style={{
                                    color: '#333',
                                    background: '#ffffff',
                                    width: '100%',
                                    textAlign: 'right',
                                    paddingRight: 30,
                                    paddingTop: 10,
                                    paddingBottom: 10,
                                    fontSize: 20,
                                }}
                                ><span onClick={this.hiddenPdflModal} style={{ cursor: 'pointer' }}>X</span></div>
                                <PdfView ref="pdfView" />
                            </div>
                        </div> : ''
                }

            </div>
        );
    }
}

export default ContractManageFile;